import { c as _c } from "react/compiler-runtime";
import { AmericanExpressIcon } from './payment-icons/american-express-icon';
import { ApplePayIcon } from './payment-icons/apple-pay-icon';
import { GooglePayIcon } from './payment-icons/google-pay-icon';
import { KlarnaIcon } from './payment-icons/klarna-icon';
import { MastercardIcon } from './payment-icons/mastercard-icon';
import { PayPalIcon } from './payment-icons/paypal-icon';
import { VisaIcon } from './payment-icons/visa-icon';
const paymentMethods = [{
  id: 'paypal',
  Icon: PayPalIcon
}, {
  id: 'apple-pay',
  Icon: ApplePayIcon
}, {
  id: 'google-pay',
  Icon: GooglePayIcon
}, {
  id: 'klarna',
  Icon: KlarnaIcon
}, {
  id: 'mastercard',
  Icon: MastercardIcon
}, {
  id: 'american-express',
  Icon: AmericanExpressIcon
}, {
  id: 'visa',
  Icon: VisaIcon
}];
interface PaymentMethodsListProps {
  className?: string;
}
export function PaymentMethodsList(t0) {
  const $ = _c(3);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "flex gap-2 sm:gap-6" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = paymentMethods.map(_temp);
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== className) {
    t3 = <ul className={className}>{t2}</ul>;
    $[1] = className;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
}
function _temp(t0) {
  const {
    id,
    Icon
  } = t0;
  return <li key={id}><Icon /></li>;
}